<div class="auth-flow" [class.auth-flow--parent]="isParentLayout()">
  <h3 class="auth-flow__title">{{ 'app.auth.resetPasswordTitle' | translate }}</h3>
  <p class="auth-flow__description">
    {{ 'app.auth.resetPasswordDescription' | translate }}
  </p>

  <form [formGroup]="form">
    <app-input-field
      formControlName="userName"
      [label]="'app.auth.userName' | translate"
      [inputType]="'input'"
      [type]="'text'"
      [validationErrors]="userNameValidation()"
      (keydown.enter)="onSubmit()"
    />

    <div class="auth-flow__cta">
      @if (isParentLayout()) {
        <app-parent-button
          [fullWidth]="true"
          [loading]="isLoading()"
          [disabled]="form.invalid"
          (clicked)="onSubmit()"
        >
          {{ 'app.auth.sendResetCode' | translate }}
        </app-parent-button>
      } @else {
        <app-cta-button [loading]="isLoading()" [disabled]="form.invalid" (clicked)="onSubmit()">
          <span cta-label>{{ 'app.auth.sendResetCode' | translate }}</span>
        </app-cta-button>
      }
    </div>
  </form>

  <button type="button" class="auth-flow__link" (click)="goToSignin()">
    {{ 'app.auth.backToSignIn' | translate }}
  </button>
</div>
